(() => {
  const SCRIPT = document.currentScript;
  const QA_SRC = SCRIPT?.dataset.ppQaSrc;
  const EXPLICIT_FRAME_SELECTOR = '[data-pp-exact-media]';
  const GALLERY_SELECTORS = ['.ppsl-buy-gallery__stage', '.ppadv-gallery__stage', '.ppas-gallery__stage'];
  const FRAME_SELECTOR = [EXPLICIT_FRAME_SELECTOR, ...GALLERY_SELECTORS].join(',');
  const frames = new Set();
  const pending = new Set();
  let scheduled = false;

  const applyExactRatio = (frame, image) => {
    if (!frame || !image) return;
    const width = image.naturalWidth || Number(image.getAttribute('width'));
    const height = image.naturalHeight || Number(image.getAttribute('height'));
    if (!(width > 0 && height > 0)) return;
    if (!frame.classList.contains('pp-exact-media-frame')) frame.classList.add('pp-exact-media-frame');
    const ratio = `${width} / ${height}`;
    if (frame.style.getPropertyValue('--pp-exact-media-ratio') !== ratio) frame.style.setProperty('--pp-exact-media-ratio', ratio);
    if (frame.dataset.ppExactMediaRatio !== `${width}:${height}`) frame.dataset.ppExactMediaRatio = `${width}:${height}`;
    if (!image.classList.contains('pp-exact-media-image')) image.classList.add('pp-exact-media-image');
  };

  const explicitImage = (frame) => {
    const image = frame.querySelector('img');
    if (!image || image.naturalWidth < 240 || image.getBoundingClientRect().width < 120) return null;
    return image;
  };

  const galleryImage = (stage) => Array.from(stage.querySelectorAll('img')).find((image) => (
      !image.hidden && !image.closest('[hidden]') && getComputedStyle(image).display !== 'none'
    ));

  const scan = () => {
    const updates = [];
    pending.forEach((frame) => {
      if (!frame.isConnected || !frame.matches(FRAME_SELECTOR)) {
        frames.delete(frame);
        return;
      }
      const image = frame.matches(EXPLICIT_FRAME_SELECTOR) ? explicitImage(frame) : galleryImage(frame);
      if (image) updates.push([frame, image]);
    });
    pending.clear();
    // Finish layout reads before writing styles to avoid repeated forced reflows.
    updates.forEach(([frame, image]) => applyExactRatio(frame, image));
  };

  const queue = (frame) => {
    frames.add(frame);
    pending.add(frame);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  };

  const discover = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(FRAME_SELECTOR)) queue(root);
    root.querySelectorAll(FRAME_SELECTOR).forEach(queue);
  };
  const queueAll = () => frames.forEach(queue);
  const changed = (node) => {
    if (node.nodeType !== 1) return;
    const frame = node.closest(FRAME_SELECTOR);
    if (frame) queue(frame);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => discover(document), { once: true });
  } else {
    discover(document);
  }
  document.addEventListener('click', queueAll, true);
  document.addEventListener('load', (event) => {
    if (event.target instanceof HTMLImageElement) changed(event.target);
  }, true);
  window.addEventListener('resize', queueAll, { passive: true });
  new MutationObserver((records) => {
    records.forEach((record) => {
      changed(record.target);
      if (record.type === 'childList') {
        record.addedNodes.forEach(discover);
        if (record.removedNodes.length) {
          frames.forEach((frame) => {
            if (!frame.isConnected) {
              frames.delete(frame);
              pending.delete(frame);
            }
          });
        }
      } else if (record.attributeName === 'hidden') {
        // A hidden ancestor may reveal an explicitly scoped media frame.
        record.target.querySelectorAll(FRAME_SELECTOR).forEach(queue);
      }
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'src', 'srcset'],
  });

  if (QA_SRC && new URLSearchParams(window.location.search).has('pp_internal')) {
    const qa = document.createElement('script');
    qa.src = QA_SRC;
    qa.defer = true;
    document.head.appendChild(qa);
  }
})();
